import { useState } from "react"
import * as Yup from 'yup'
import { useFormik } from 'formik'
import { toast } from "react-toastify"
import { authCRUD } from "../../../actions/auth"

const schema = Yup.object().shape({
  new_password: Yup.string().min(8, 'Minimum 8 characters').required('New password is required'),
  confirm: Yup.string().oneOf([Yup.ref('new_password'), null], 'Passwords must match').required('Confirm the password'),
})

/**
 * Admin reset-password modal. Sets a new password for the selected user
 * WITHOUT requiring the old password (PUT /user/reset-password/<id>).
 */
export const ResetPassword = ({ user }) => {
  const [loading, setLoading] = useState(false)
  const [show, setShow] = useState(false)

  const formik = useFormik({
    enableReinitialize: true,
    initialValues: { new_password: '', confirm: '' },
    validationSchema: schema,
    onSubmit: (values, { resetForm, setSubmitting }) => {
      if (!user) return
      setLoading(true)
      authCRUD.resetUserPassword(user.id, { new_password: values.new_password })
        .then(() => {
          toast.success(`Password reset for ${user.username}.`, { autoClose: 7000 })
          resetForm()
        })
        .catch((error) => {
          toast.error(error?.response?.data?.new_password?.[0] || error?.message || 'Reset failed', { autoClose: 7000 })
        })
        .finally(() => {
          setLoading(false)
          setSubmitting(false)
        })
    }
  })

  return (
    <div className="modal fade resetPasswordModal" tabIndex="-1" aria-hidden="true">
      <div className="modal-dialog">
        <div className="modal-content">
          <div className="modal-header">
            <h5 className="modal-title">Reset Password {user?.username ? `— ${user.username}` : ''}</h5>
            <button type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
          </div>
          <form onSubmit={formik.handleSubmit}>
            <div className="modal-body">
              <div className="mb-3 position-relative">
                <label className="form-label">New Password <span className="text-danger">*</span></label>
                <input
                  type={show ? "text" : "password"}
                  className="form-control"
                  placeholder="Enter new password"
                  {...formik.getFieldProps('new_password')}
                />
                {formik.touched.new_password && formik.errors.new_password && (
                  <span className='text-danger' style={{ fontSize: '13px' }}>{formik.errors.new_password}</span>
                )}
              </div>
              <div className="mb-3">
                <label className="form-label">Confirm Password <span className="text-danger">*</span></label>
                <input
                  type={show ? "text" : "password"}
                  className="form-control"
                  placeholder="Re-enter new password"
                  {...formik.getFieldProps('confirm')}
                />
                {formik.touched.confirm && formik.errors.confirm && (
                  <span className='text-danger' style={{ fontSize: '13px' }}>{formik.errors.confirm}</span>
                )}
              </div>
              <div className="form-check">
                <input className="form-check-input" type="checkbox" id="showpw" checked={show} onChange={() => setShow(!show)} />
                <label className="form-check-label" htmlFor="showpw">Show password</label>
              </div>
            </div>
            <div className="modal-footer">
              <button type="button" className="btn btn-soft-danger" data-bs-dismiss="modal">Close</button>
              <button type="submit" className="btn btn-soft-success" disabled={formik.isSubmitting}>
                {!loading && <span><i className="ri-key-2-line me-1"></i> Reset Password</span>}
                {loading && <span>Please wait... <span className='spinner-border spinner-border-sm ms-2'></span></span>}
              </button>
            </div>
          </form>
        </div>
      </div>
    </div>
  )
}
